"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var page_1 = require("../pages/home/page");
var history_1 = require("../shared/history");
var qs = require("qs");
var Cookies = require('js-cookie');
var RECReferralToken = 'RECReferralToken';
var ReferralTokenChecker = (function () {
    function ReferralTokenChecker() {
    }
    ReferralTokenChecker.checkForReferralToken = function () {
        var params = page_1.getQueryParams();
        var referralToken = params.referralToken;
        if (referralToken) {
            if (localStorage) {
                localStorage.setItem(RECReferralToken, referralToken);
            }
            else {
                Cookies.set(RECReferralToken, referralToken);
            }
        }
        else {
            var token = localStorage ? localStorage.getItem(RECReferralToken) : Cookies.get(RECReferralToken);
            if (token) {
                this.addReferralTokenToURL(token, params);
            }
        }
    };
    ReferralTokenChecker.addReferralTokenToURL = function (token, params) {
        params["referralToken"] = encodeURIComponent(token);
        history_1.default.replace({
            pathname: window.location.pathname,
            search: "?" + qs.stringify(params, { encode: false })
        });
    };
    ;
    return ReferralTokenChecker;
}());
exports.ReferralTokenChecker = ReferralTokenChecker;



//////////////////
// WEBPACK FOOTER
// C:/WS/ls/build/player-career-site/src/shared/ReferralTokenChecker.ts
// module id = 345
// module chunks = 0